import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ButtonCancel, ButtonPrimary } from './buttons/Button';
import SidePanel from './SidePanel';

class SidePanelCrop extends Component {
  render() {
    return (
      <SidePanel title="Crop Image">
        <ButtonCancel cancel addSpacing onClick={this.props.onDelete}>
          Reset Crop
        </ButtonCancel>
        <ButtonPrimary addSpacing onClick={this.props.onClose}>
          Done
        </ButtonPrimary>
      </SidePanel>
    );
  }
}

SidePanelCrop.propTypes = {
  onDelete: PropTypes.func,
  onClose: PropTypes.func,
};

SidePanelCrop.defaultProps = {
  onDelete: () => {},
  onClose: () => {},
};

export default SidePanelCrop;
